<p-panel [toggleable]="true" [collapsed]="!isFirst()" toggler="header">
  <ng-template #header>
    <div class="flex items-center justify-between w-full gap-6">
      <div class="flex items-end gap-2">
        <span class="font-bold">
          {{ officeModule().officeName }}
        </span>
        <span class="text-sm text-muted-color">
          {{ moduleSystemRecordingCount() }}
          {{ 'project.steps.systems' | transloco }}
        </span>
      </div>
    </div>
  </ng-template>
  <ng-template #headericons let-collapsed>
    <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
  </ng-template>

  <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-4 p-2">
    @for (moduleSystemRecording of moduleSystemRecording(); track $index) {
      <app-hr-system-recording-card
        [moduleFunctions]="moduleFunctions()"
        [moduleSystemRecording]="moduleSystemRecording"
      />
    }
  </div>
</p-panel>
